import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { getHandlingUnitTypesForDropdown } from "@/Data/getHandlingUnitTypesForDropdown";
import { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";

import { LineItemsIsStackableQuestionBubble } from "../Bubbles/LineItemsIsStackableQuestionBubble";

interface IsStackableInputProps {
  isStackable: boolean | undefined;
  onChange: (value: boolean) => void;
  usePlural: boolean;
  handlingUnitType: HandlingUnitType | undefined;
  errorMessage?: ErrorMessageType | undefined;
  forceValidation?: boolean | undefined;
}

const LineItemsIsStackableInput: React.FC<IsStackableInputProps> = (
  props: IsStackableInputProps,
) => {
  function descriptionWithHandlingUnitType() {
    const handlingTypes = getHandlingUnitTypesForDropdown(props.usePlural);

    const item = handlingTypes.find((t) => t.value === props.handlingUnitType);

    if (item === undefined) {
      throw new Error(`Missing handling unit type ${props.handlingUnitType}`);
    }

    const handlingTypeDescription = item.label;

    const verb = props.usePlural ? "are" : "is";

    return `${handlingTypeDescription} ${verb} stackable`;
  }

  const stackableDescription =
    props.handlingUnitType === undefined ||
    props.handlingUnitType === HandlingUnitType.Other
      ? "Stackable"
      : descriptionWithHandlingUnitType();

  const options = [
    { value: "false", label: "Not stackable" },
    { value: "true", label: stackableDescription },
  ];

  const selectedValue =
    props.isStackable === undefined ? undefined : String(props.isStackable);

  return (
    <ShowFormErrors show={Boolean(props.forceValidation)}>
      <FormItem
        label={
          <>
            Is Stackable?
            <LineItemsIsStackableQuestionBubble />
          </>
        }
        error={props.errorMessage}
      >
        <Dropdown
          options={options}
          value={selectedValue}
          width="full"
          onChange={(v) => props.onChange(v === "true")}
          placeholder="Can other freight be put on top of it?"
          renderOption={(option) => (
            <Row justify="between" align="center">
              {option.label}
              <img
                src={
                  option.value === "true"
                    ? "/stackable.png"
                    : "/not-stackable.png"
                }
                width="32"
                alt=""
              />
            </Row>
          )}
          data-testid="isStackableControl"
        />
      </FormItem>
    </ShowFormErrors>
  );
};
export default LineItemsIsStackableInput;
